import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { styleBlock } from "../styleBlock";
export default class NotificationBar extends React.PureComponent {
    render() {
        const { className, cancellable = true, children, cancelButtonBlack, onCancel, variant = "info", translateFunc, cancelButtonInfoId, } = this.props;
        const classNames = styleBlock("notification-bar")({ variant: variant });
        const cn = classNames.mix([className]);
        return (React.createElement("div", { className: cn.toString() },
            React.createElement(Container, { fluid: "xl", className: "p-0" },
                React.createElement(Row, { noGutters: true },
                    React.createElement(Col, { className: "notification-container" }, children))),
            cancellable && (React.createElement("button", { className: `notification-close${cancelButtonBlack ? " notification-close_black" : ""}`, onClick: onCancel, type: "button", role: "button", "aria-label": translateFunc("close_button"), "aria-describedby": cancelButtonInfoId },
                React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", "aria-hidden": "true", focusable: "false" },
                    React.createElement("path", { d: "M1.05029 10.9498L10.9498 1.05027", stroke: "currentColor" }),
                    React.createElement("path", { d: "M1.05029 1.05023L10.9498 10.9497", stroke: "currentColor" }))))));
    }
}
//# sourceMappingURL=index.js.map